<template>
  <v-card flat class="mt-4 mb-4">
    <v-card-title class="blue">
      <span class="subtitle-1">
        Callsheet details and assigment for "{{itemName}} ({{itemRole}})"
      </span>
      <v-spacer></v-spacer>

      <v-icon :color="hideIconColor" @click.stop="expandRow">
        {{ hideIcon }}
      </v-icon>
    </v-card-title>

    <callsheet-analysis-assign 
      :target-item="item" 
      :reason="reason"
      @hideclose="hideClose"
    >
    </callsheet-analysis-assign >

    <callsheet-analysis-expand-detail :item="item">
    </callsheet-analysis-expand-detail >

    <kgraph-panel :item="kgraph">
    </kgraph-panel>

    <v-card-actions class="blue">
      <v-spacer></v-spacer>
      
      <v-btn text :disabled="hidingClose">
        <span class="caption">Close  {{item.person}}</span>
        <v-icon :color="closeIconColor" @click.stop="expandRow">
          {{ closeIcon }}
        </v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { getIconColor, getIcon } from '@/js/store'
import Callsheetanalysisassign from '@/components/Callsheetanalysisassign'
import Kgraphpanel from '@/components/Kgraphpanel'
import Callsheetanalysisexpanddetail from '@/components/Callsheetanalysisexpanddetail'
export default {
  props: {
    item: Object,
    reason: Object
  },
  components: {
    'kgraph-panel' : Kgraphpanel,
    'callsheet-analysis-expand-detail' : Callsheetanalysisexpanddetail,
    'callsheet-analysis-assign': Callsheetanalysisassign
  },
  data: () => ({
    hidingClose: false,
    expandedAssign: false
  }),
  methods: {
    expandRow () {
      this.$emit('expand')
    },  
    hideClose (b) {
      this.hidingClose = Boolean(b)
    },
    expandAssign () {
      this.expandedAssign = !this.expandedAssign
    },
    getIcon (name) {
      return getIcon(name)
    },
    getIconColor (name) {
      return getIconColor(name)
    },
  },
  computed: {
    isExpandedAssign () {
      return this.expandedAssign
    },
    kgraph () {
      return this.item && this.item.Kgraph
    },
    typeIcon () {
      return getIcon(this.item.type)
    },
    typeIconColor () {
      return getIconColor(this.item.type)
    },
    closeIcon () {
      return getIcon('close')
    },
    closeIconColor () {
      return getIconColor('close')
    },
    hideIcon () {
      return getIcon('hide')
    },
    hideIconColor () {
      return getIconColor('hide')
    },
    itemName () {
      return this.item.person
    },
    itemRole () {
      return this.item.profession
    }
  }
}
</script>
